import _orderBy from 'lodash/orderBy';


export const state = {
    sortCurrentChildPublicFile: {
        loading: false,
        data: [],
    },
}


export const getters = {
}


export const mutations = {
    // SORTING FILE
    sortByFile: (state, data) => {
        let selectedItems = data.items;

        let order = data.order;
        let key = data.key;

        state.sortCurrentChildPublicFile.data = selectedItems;

        state.sortCurrentChildPublicFile.data = _orderBy(selectedItems, `fileManager.${key}`, order.toLowerCase());
    }
}


export const actions = {
}